import * as actionTypes from '../actionTypes';

const state = {
  isLoadingGetIsDoneFirstTime: false,
  getIsDoneFirstTimeMessage: '',
  getIsDoneFirstTimeFailed: '',
};

const initialState = JSON.parse(JSON.stringify(state));

function commonActionReducer(globalstate = state, action) {
  switch (action.type) {
    case actionTypes.INITIALIZE_STATES_FULFILLED:
      return {
        ...initialState,
      };
    case actionTypes.GET_IS_DONE_FIRST_TIME_PENDING:
      return {
        ...globalstate,
        isLoadingGetIsDoneFirstTime: true,
      };
    case actionTypes.GET_IS_DONE_FIRST_TIME_FULFILLED:
      return {
        ...globalstate,
        isLoadingGetIsDoneFirstTime: false,
        getIsDoneFirstTimeMessage: action.data,
        getIsDoneFirstTimeFailed: '',
      };
    case actionTypes.GET_IS_DONE_FIRST_TIME_FAILURE:
      return {
        ...globalstate,
        isLoadingGetIsDoneFirstTime: false,
        getIsDoneFirstTimeMessage: '',
        getIsDoneFirstTimeFailed: action.error,
      };
    default:
      return globalstate;
  }
}

export { commonActionReducer as default };
